import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Shield, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  return <div id="pricing" className="bg-gradient-to-b from-cream to-sage/20 py-24" data-id="element-1">
      <Section data-id="element-2">
        {/* Why Choose Us - Pre CTA */}
        <div className="mb-24 text-center max-w-3xl mx-auto" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-8" data-id="element-4">
            ¿POR QUÉ ELEGIR TU AURA SIMPLE?
          </h2>
          <div className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl shadow-sm border border-white" data-id="element-5">
            <p className="text-xl text-gray-700 italic font-heading leading-relaxed mb-8" data-id="element-6">
              "Creemos en la espiritualidad que se puede aplicar mientras tomas
              un café o antes de dormir. Sin rituales extraños, sin mística
              complicada. Solo vos, tu conciencia y el poder del Yo Soy."
            </p>
            <img src="https://cdn.magicpatterns.com/uploads/6pWJMAggcgSCbmH86h4GdK/Logo_Tu_Aura_Ok_Ok.png" alt="Logo" className="w-16 h-16 mx-auto object-contain opacity-80" data-id="element-7" />
          </div>
        </div>

        {/* Main CTA Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-sage/20" data-id="element-8">
          <div className="bg-navy text-white p-4 text-center" data-id="element-9">
            <span className="flex items-center justify-center gap-2 text-sm font-bold tracking-widest uppercase" data-id="element-10">
              <Sparkles size={16} className="text-gold" data-id="element-11" />
              Oferta Especial
              <Sparkles size={16} className="text-gold" data-id="element-12" />
            </span>
          </div>

          <div className="p-8 md:p-16 text-center" data-id="element-13">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-navy mb-4" data-id="element-14">
              RECLAMA TU REINO INTERIOR HOY
            </h2>
            <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-15">
              La paz y la abundancia no se buscan fuera, se asumen dentro. No
              esperes a que las circunstancias mejoren para ser feliz; sé feliz
              y mira cómo las circunstancias se transforman.
            </p>

            <div className="mb-10" data-id="element-16">
              <div className="text-6xl font-bold text-sage-dark font-heading mb-2" data-id="element-17">
                $9.999
              </div>
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-18">
                <span data-id="element-19">Acceso inmediato al PDF</span>
                <span className="hidden md:inline" data-id="element-20">•</span>
                <span data-id="element-21">Pago único</span>
                <span className="hidden md:inline" data-id="element-22">•</span>
                <span data-id="element-23">Sin suscripciones</span>
              </div>
            </div>

            <Button id="cta-button" variant="primary" size="lg" withArrow pulse className="w-full md:w-auto min-w-[300px]" onClick={() => {
            trackAddToCart();
            window.location.href = 'https://tuaurasimple.com/cart/54276887707951:1';
          }} data-id="element-24">
              QUIERO MI EBOOK Y EMPEZAR MI DESPERTAR
            </Button>

            <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-25">
              <Shield size={14} data-id="element-26" />
              <span data-id="element-27">Compra 100% segura</span>
            </div>
          </div>
        </motion.div>
      </Section>
    </div>;
}